import { createAction, props } from '@ngrx/store';
import { IApiResponseError } from '@app/api/interfaces/common/api-response-error.interface';
import { BaseErrorStatus } from '@app/api/enums/base-error-status.enum';
import { IUserMe } from '@app/api/interfaces/user-me.interface';

export const getUserMe = createAction('[UserMe] Get UserMe');

export const getUserMeSuccess = createAction(
  '[UserMe] Get UserMe Success',
  props<{
    data: IUserMe;
  }>()
);

export const userMeError = createAction(
  '[UserMe] UserMe Error',
  props<{
    error: IApiResponseError<BaseErrorStatus>;
  }>()
);
